import { Link } from 'react-router-dom';
import { articleDetail } from '@/mocks/article';

export default function ArticleHeader() {
  return (
    <section className="relative w-full pt-20 pb-12 md:pt-24 md:pb-16 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap items-center gap-2 mb-4">
            <Link
              to={`/category/${articleDetail.categorySlug}`}
              className="px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap hover:bg-primary-200 transition-colors cursor-pointer"
            >
              {articleDetail.category}
            </Link>
            {articleDetail.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 bg-background-200/70 text-foreground-600 text-xs rounded-full whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>

          <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-6">
            {articleDetail.title}
          </h1>

          <div className="flex flex-wrap items-center gap-4 text-xs md:text-sm text-foreground-500 mb-8">
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-user-line"></i>
              </span>
              {articleDetail.author}
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-time-line"></i>
              </span>
              {articleDetail.time}
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-fire-line"></i>
              </span>
              {articleDetail.heat} 热度
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-building-line"></i>
              </span>
              {articleDetail.source}
            </span>
          </div>

          <div className="relative w-full rounded-lg overflow-hidden">
            <img
              src={articleDetail.image}
              alt={articleDetail.title}
              title={`${articleDetail.title} - 吃瓜网站线路一`}
              className="w-full h-auto object-cover object-top max-h-[500px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}